export default "__VITE_ASSET__DmGias9l__"